import Vue from 'vue'
import configs from '@/config'
import { AI_USAGE_RESULTS_PATH } from '@/business-logic/ai-usage/aiUsageWire'

const actions = {
  getSettledResult: {
    method: 'GET',
    url: `${configs.baseUrl}${AI_USAGE_RESULTS_PATH}`,
  },
  lookupById: {
    method: 'GET',
    url: `${configs.baseUrl}${AI_USAGE_RESULTS_PATH}/{resultId}`,
  },
}

let resource = null

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const bodyOrNullOn404 = async (request) => {
  try {
    const res = await request
    return res.body || null
  } catch (error) {
    if (error && error.status === 404) return null
    throw error
  }
}

/**
 * The latest settled AI usage result bound to one resource and job.
 * @param {Object} query
 * @param {string} query.resourceType
 * @param {string|number} query.resourceId
 * @param {string|number} query.jobId
 * @returns {Promise<Object|null>} the settlement, or null when there is none to show (404: flag off,
 *   not settled yet, not found or not allowed)
 */
const getSettledResult = ({ resourceType, resourceId, jobId }) => {
  if (!resource) initResource()
  return bodyOrNullOn404(resource.getSettledResult({ resourceType, resourceId, jobId }))
}

/**
 * One result by id: settled, or `settlement: "pending"` with null values until it settles.
 * @param {string} resultId
 * @returns {Promise<Object|null>} null on 404 (flag off, not found or not allowed)
 */
const lookupById = (resultId) => {
  if (!resource) initResource()
  return bodyOrNullOn404(resource.lookupById({ resultId }))
}

export default {
  initResource,
  getSettledResult,
  lookupById,
}
